import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { SERVICE_TEMPLATE_ID_PATTERN } from "@constants/url-parameter-patterns";
import { ServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";

type UpdateServiceTemplateRequestResponse = {
    transferObject: ServiceTemplateDetails;
};

export const updateServiceTemplateRequest = async (
    serviceTemplate: ServiceTemplateDetails
): Promise<GenericNetworkResponse<UpdateServiceTemplateRequestResponse>> => {
    const route = injectCustomIdParameter(
        apiRoutes.serviceConfiguration.data.serviceTemplateWithId,
        serviceTemplate.id, SERVICE_TEMPLATE_ID_PATTERN
    );

    const { id, name, description, ssoTemplate, organizationID, status } = serviceTemplate;
    const body: Partial<ServiceTemplateDetails> = {
        id,
        name,
        description,
        ssoTemplate,
        organizationID,
        status
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};